const key = "accelerated-checkout";
const className = "experiment--one-step-checkout-1";

export const acceleratedCheckout = {
    key: key,
    init: (active) => {
        console.log("[accelerated-checkout] active:", active);
        document.body.classList.toggle(className, !!active);
    }
}
